import { combineReducers } from 'redux'

import authentication from './authentication.reducer'
import users from './users.reducer'
import clients from './clients.reducer'
import projects from './projects.reducer'
import departments from './departments.reducer'
import pipedrive from './pipedrive.reducer'
import tasksissues from './tasksissues.reducer'
import timesheet from './timesheet.reducer'
import common from './common.reducer'

export default combineReducers({
    authentication,
    users,
    clients,
    projects,
    departments,
    pipedrive,
    tasksissues,
    timesheet,
    common,
})


// WEBPACK FOOTER //
// ./src/_reducers/index.js